<template>
  <ul class="product-list clearfix">
    <li class="product-item" :class="{'no-img': !productImg}"
      v-for="(item, index) in list"
      :key="item.productid"
      @click="handleTap(item)"
      >
        <img class="icon" v-if="item.icon" :src="item.icon">
        <img class="icon" v-if="!item.icon && item.activityIcon" :src="item.activityIcon">
        <div class="product-logo-wrapper" v-if="productImg">
          <img class="product-logo" v-lazy="item.productLogo" :key="item.productLogo" :alt="item.productName">
        </div>
        <div v-if="item.activityText" class="activity-text">{{ item.activityText }}</div>
        <div :data-index="index + 1" class="product-name">{{ item.productName }}</div>
      </li>
  </ul>
</template>

<script>

export default {
  props: {
    list: Array,
    productImg: Boolean
  },
  methods: {
    handleTap (data) {
      this.$emit('onProductChanged', data);
    }
  }
};
</script>

<style src="./product-list.css" scoped></style>



// WEBPACK FOOTER //
// src/core/product-list/product-list.vue